import React from 'react'
import { Box, Typography, Container,    } from '@mui/material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';

import Grid from '../../../common/CustomGrid';

export default function PageHeader({title, next = null, prev = null, hrefPrev = null, hrefNext = null}) {
  return (
    <Box className="page-header" sx={{  py: 4  }} >
      <Container>
        
          <Grid container spacing={1} className="page-navigation-container">
            <Grid size={{xs:6}}>
              {prev &&
                <Typography className="page-navigation prev" component="a" href={hrefPrev} sx={{ gap: 1, color: 'text.primary', '&:hover': {color: 'primary.main'} }} >
                  <ArrowBackIosNewIcon fontSize="small" /> {prev} 
                </Typography>
              }
            </Grid>
            <Grid size={{xs:6}}>
                {next &&
                  <Typography className="page-navigation next" component="a" href={hrefNext} sx={{ gap: 1, color: 'text.primary', '&:hover': {color: 'primary.main'} }} >
                    {next} <ArrowForwardIosIcon fontSize="small" />
                  </Typography>
                }
            </Grid>
          </Grid>
          
        <Typography className="section-title" variant="h1" color="primary" >
           {title}
        </Typography>

       
        
      </Container>     
    </Box>
  )
}
